exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".selectorOverrideStyles__selector___HytXz{color:#fff;background-color:#9ea900}.selectorOverrideStyles__option___2goi8{color:#9ea900}", ""]);

// exports
exports.locals = {
	"selector": "selectorOverrideStyles__selector___HytXz",
	"option": "selectorOverrideStyles__option___2goi8"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/PagePerformance/overrides/selectorOverrideStyles.pcss
// module id = 927
// module chunks = 0